import { useEffect } from 'react';
import './Header.css';
import { waitForElement } from "../../utils/GlobalFunctions.js";
import { STORE_DARK_MODE } from "../../utils/Constants.js";

const Header = () => {
	//======================//
	//=  Hamburger toggle  =//
	//======================//
	let closed = true;
	const menuClosed = "/static/icons/hamburger.svg";
	const menuOpen = "/static/icons/close.svg";
	const burgerClicked = () => {
		let page = document.getElementById("slideable-content");
		let burger = document.getElementById("burger");
		if (closed) {
			burger.src = menuOpen;
		} else {
			burger.src = menuClosed;
		}
		closed = !closed;
		page.classList.toggle("slide-right");
	};

	//======================//
	//=  Dark mode toggle  =//
	//======================//
	let darkMode = false;
	const sunIcon = "light_mode";
	const moonIcon = "dark_mode";
	const sunClicked = () => {
		let sun = document.getElementById("sun");
		darkMode = !darkMode;
		document.documentElement.classList.toggle("dark-mode");
		localStorage.setItem(STORE_DARK_MODE, darkMode); // Store boolean as string
		if (darkMode) {
			sun.innerHTML = moonIcon;
		} else {
			sun.innerHTML = sunIcon;
		}
	};
	waitForElement('#sun').then((sun) => {
		// Check string on page load and simulate the switch
		if (localStorage.getItem(STORE_DARK_MODE) === "true") {
			darkMode = true
			document.documentElement.classList.add("dark-mode");
			sun.innerHTML = moonIcon;
		}
	});

	//=========================//
	//=  Dropdown animations  =//
	//=========================//
	useEffect(() => {
		const loadElements = async () => {
			[
				{ trigger: await waitForElement('#aboutTrigger'), dropdown: await waitForElement('#aboutDropdown') },
				{ trigger: await waitForElement('#eventsTrigger'), dropdown: await waitForElement('#eventsDropdown') },
				{ trigger: await waitForElement('#toolsTrigger'), dropdown: await waitForElement('#toolsDropdown') },
				{ trigger: await waitForElement('#prayerTrigger'), dropdown: await waitForElement('#prayerDropdown') },
			].forEach(({ trigger, dropdown }) => {
				const transformDropdown = (hovering) => {
					if (hovering) {
						const height = dropdown.scrollHeight;
						dropdown.style.transform = `translateY(`+height+`px)`;
					} else {
						dropdown.style.transform = `translateY(0px)`;
					}
				}

				trigger.addEventListener('mouseover', () => {
					transformDropdown(true);
				});
				dropdown.addEventListener('mouseover', () => {
					transformDropdown(true);
				});
				trigger.addEventListener('mouseout', () => {
					transformDropdown(false);
				});
				dropdown.addEventListener('mouseout', () => {
					transformDropdown(false);
				});
			});
		}
		loadElements();
	}, []);
	
	return (
		<header>
			<div className="bg-nav">
				<nav className="nav-flex nav-flex-left">
					<div id="aboutTrigger"><a href="/">About Us</a></div>
					<div id="aboutDropdown" className="dropdown">
						<div><a href="/officers">Meet the Team</a></div>
						<div><a href="/join">Join the Society</a></div>
						<div><a href="/history">Our History</a></div>
					</div>
					<div id="eventsTrigger"><a href="/events">Events</a></div>
					<div id="eventsDropdown" className="dropdown">
						<div><a href="/upcoming_events">Upcoming Events</a></div>
						<div><a href="/previous_events">Previous Events</a></div>
					</div>
				</nav>
				<nav className="nav-flex nav-flex-right">
					<div id="toolsTrigger"><a href="/tools">Tools</a></div>
					<div id="toolsDropdown" className="dropdown">
						<div><a href="/bulletins">Bulletin Viewer</a></div>
						<div><a href="/litcal">Liturgical Day</a></div>
					</div>
					<div id="prayerTrigger"><a href="/prayer">Prayer</a></div>
					<div id="prayerDropdown" className="dropdown">
						<div><a href="/rosary">Rosary Companion</a></div>
						<div><a href="/sorrows">Seven Sorrows</a></div>
						<div><a href="/chaplet">Holy Name Chaplet</a></div>
						<div><a href="/mercy">Divine Mercy Chaplet</a></div>
					</div>
					{/* <div><a href="/members_only">Members</a></div> */}
					{/* <div><a href="/contact">Contact</a></div> */}
				</nav>
				<div className="burger-flex">
					<img id="burger" src="/static/icons/hamburger.svg" alt="burger" onClick={burgerClicked} />
				</div>
				<div className="sun-flex">
					<button id="sunButton" onClick={sunClicked} aria-label="Toggle light mode">
						<span id="sun" className="material-symbols-outlined">light_mode</span>
					</button>
				</div>
			</div>
			<div className="bg-circle">
				<img src="/static/images/HNS-emblem.png" alt="HNS Icon" />
			</div>
		</header>
	);
};

export default Header;
